// extracted by mini-css-extract-plugin
export default {"wrapper":"RiwayatPresensi_wrapper__A20mq","title":"RiwayatPresensi_title__XeX8d","subTitle":"RiwayatPresensi_subTitle__zD2nT","button":"RiwayatPresensi_button__WZe3M"};